<template>
  <router-view v-if="showRouter"/>
  <phonedialog  ref="phonedialogref"/>
</template>
<script setup>
import { onMounted,ref } from 'vue'
import { useStore } from 'vuex'
import {useRoute,useRouter} from 'vue-router'
import {showLoadingToast,closeToast} from 'vant'
import api from '@/api'
import phonedialog from '@/components/phone_dialog.vue'
const route = useRoute()
const router = useRouter()
const phonedialogref = ref(null)
const store = useStore()
const showRouter = ref(true)
onMounted( async ()=>{
  // 添加异步阻塞，等待隐式登录完成
  await new Promise((resolve) => {
    setTimeout(resolve, 50);
  });

  console.log(route.query)
  if(route.query.token&&route.query.user_id == 0&&store.state.userInfo.hasLogin == false){
    phonedialogref.value.show = true
  }else if(route.query.token&&route.query.user_id != 0&&store.state.userInfo.hasLogin == false){
    store.commit('setToken',route.query.token)
    showLoadingToast({
      message: '登录中...',
      forbidClick: true,
    });
    api.getUserInfo({appid:store.state.userInfo.appid}).then(res=>{
      if(res){
        store.commit('setInfo',res.data)
        closeToast()
      }
    })
  }
})
function isXhn(){
      var UA = window.navigator.userAgent;
      var isAndroid = UA.indexOf('Android') > 0;
      var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
      var isXinhunan = false;
       var isHarmony = UA.indexOf('OpenHarmony') > 0;
      
      if (isAndroid || isIOS||isHarmony) {
        //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
        if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
        {
          isXinhunan = true;
        }	
      }
      return isXinhunan;
    }
window['onLoad'] = (e) =>{
  vmobile.getUserInfoForVote();//隐式登录
}
if(!isXhn()){
  store.commit('initInfo')
}else{
  showRouter.value = false
}
window['setUserInfoForVote'] = (res) =>{
      console.log('用户信息',res)
      if(typeof(res) == 'string'){
        res = JSON.parse(res);
      }
      if(res.username == ''){
        showRouter.value = true
        return;
      }
      store.commit('setAppid',res.appid);
      store.commit('setToken',res.token);
        api.getUserInfo({appid:res.appid}).then(res=>{
          if(res){
            store.commit('setInfo',res.data)
            showRouter.value = true
          }
        })
      // this.setInfo(res);
    }
    window['setUserInfo'] = (res) =>{
      console.log('用户信息',res)
      if(typeof(res) == 'string'){
        res = JSON.parse(res);
      }
      if(res.username == ''){
        showRouter.value = true
        return;
      }
      store.commit('setAppid',res.appid);
      store.commit('setToken',res.token);
        api.getUserInfo({appid:res.appid}).then(res=>{
          if(res){
            store.commit('setInfo',res.data)
            showRouter.value = true
          }
        })
    }
</script>
<style lang="scss">
  @import './assets/css/common.scss';
</style>
